import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

axios.defaults.withCredentials = true;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest
  const [loading, setLoading] = useState(true);
  const [financialAccess, setFinancialAccess] = useState({
    has_access: false, is_root: false,
  });
  const [kasaAccess, setKasaAccess] = useState({
    has_access: false, is_root: false,
  });
  const [ortakAccess, setOrtakAccess] = useState({ has_access: false, is_root: false });

  const refresh = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/auth/me`);
      setUser(data);
      // Gizli finansal modül yetki durumu — user login olur olmaz sessizce yüklenir
      try {
        const acc = await axios.get(`${API}/financial/access`);
        setFinancialAccess(acc.data || { has_access: false, is_root: false });
      } catch { setFinancialAccess({ has_access: false, is_root: false }); }
      // Gizli Gayri Resmi Kasa modülü yetki durumu
      try {
        const kacc = await axios.get(`${API}/kasa/access`);
        setKasaAccess(kacc.data || { has_access: false, is_root: false });
      } catch { setKasaAccess({ has_access: false, is_root: false }); }
      try {
        const oacc = await axios.get(`${API}/ortaklar-carisi/access`);
        setOrtakAccess(oacc.data || { has_access: false, is_root: false });
      } catch { setOrtakAccess({ has_access: false, is_root: false }); }
    } catch {
      setUser(false);
      setFinancialAccess({ has_access: false, is_root: false });
      setKasaAccess({ has_access: false, is_root: false });
      setOrtakAccess({ has_access: false, is_root: false });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    // Login sonrası tam profili (permissions dahil) /auth/me üzerinden çek
    try { await refresh(); } catch { setUser(data); }
    return data;
  };

  const register = async (payload) => {
    const { data } = await axios.post(`${API}/auth/register`, payload);
    try { await refresh(); } catch { setUser(data); }
    return data;
  };

  const logout = async () => {
    await axios.post(`${API}/auth/logout`, {});
    setUser(false);
    setFinancialAccess({ has_access: false, is_root: false });
    setKasaAccess({ has_access: false, is_root: false });
    setOrtakAccess({ has_access: false, is_root: false });
  };

  /**
   * Dinamik izin matrisi kontrolü.
   * `user.permissions[module][action]` → boolean.
   * Yönetici (`yonetici`) her zaman `true`.
   */
  const hasPermission = useCallback((module, action) => {
    if (!user || user === false) return false;
    if (user.role === "yonetici") return true;
    const p = user.permissions || {};
    return Boolean(p[module]?.[action]);
  }, [user]);

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh, hasPermission,
                                financialAccess, kasaAccess, ortakAccess }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
export { API };

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
